import React, { Component } from "react";
import { PaymentService } from "@services";
import utils from "@utils";
import { ScrollDetect } from "../../components";

import "./DepositHistory.scss";

class DepositHistory extends Component {
	constructor(props) {
		super(props);

		this.state = {
			depositHistory: [],
			pagingToken: "",
			hasNext: true,
		};
	}

	/** Gets the list of the deposit history made by a coordinator */
	getDepositHistory = () => {
		const { lang } = global;
		const { pagingToken, hasNext } = this.state;

		if (hasNext) {
			PaymentService.getPayouts({ pagingToken, displayCount: 25 })
				.then(({ data }) => {
					this.setState(prevState => ({
						depositHistory: [...prevState.depositHistory, ...(data.ItemList || [])],
						pagingToken: data.PagingToken,
						hasNext: data.HasNext,
					}));
				})
				.catch(() => {
					this.setState({
						pagingToken: "",
						hasNext: false,
					});
					utils.notify({
						type: "error",
						message: lang.t("Error loading payment history"),
					});
				});
		}
	};

	/**
	 * Updates the status label with the appropriate bootstrap 3 label styles
	 * @param {String} status The status of each deposited item
	 * @returns {String} The type of label to be used for styling purposes
	 */
	getLabelColor = status => {
		let labelType = "";
		switch (status) {
			case "paid":
				labelType = "success";
				break;
			case "pending":
			case "in_transit":
				labelType = "warning";
				break;
			case "canceled":
			case "failed":
				labelType = "danger";
				break;
			default:
				labelType = "default";
				break;
		}

		return labelType;
	};

	render() {
		const { lang } = global;
		const { depositHistory, hasNext } = this.state;

		return (
			<div
				id="deposit-history"
				className="container"
			>
				<div className="row text-center">
					<h1>{lang.t("Deposit History")}</h1>
				</div>
				<div
					id="table-header"
					className="row hidden-xs"
				>
					<div className="col-sm-3">
						<strong>{lang.t("Deposit Date")}</strong>
					</div>
					<div className="col-sm-3">
						<strong>{lang.t("Status")}</strong>
					</div>
					<div className="col-sm-3">
						<strong>{lang.t("Bank Account (Last 4 digits)")}</strong>
					</div>
					<div className="col-sm-3">
						<strong>{lang.t("Amount")}</strong>
					</div>
				</div>
				<div
					id="table-body"
					className="row"
				>
					<For
						each="deposit"
						index="index"
						of={depositHistory}
					>
						<div
							key={deposit.Id}
							className="row"
						>
							<div className="col-xs-9 col-sm-3">
								{utils.formatDate(
									`${deposit.DepositDate}T00:00`,
									"en-US",
									undefined,
									"numeric",
								)}
							</div>
							<div className="col-xs-3 text-capitalize text-right">
								<span
									className={`label label-${this.getLabelColor(deposit.Status)}`}
								>
									{deposit.Status.replace("_", " ")}
								</span>
							</div>
							<div className="col-xs-12 col-sm-3">
								<If condition={deposit.BankAccountLast4}>
									<strong className="visible-xs-inline">
										{lang.t("Bank Account (Last 4 digits)")}:{" "}
									</strong>
								</If>
								{deposit.BankAccountLast4}
							</div>
							<div className="col-xs-12 col-sm-3">
								<If condition={deposit.Amount}>
									<strong className="visible-xs-inline">
										{lang.t("Amount")}:{" "}
									</strong>
								</If>
								{utils.currencyFormatter(deposit.Amount)}
							</div>
						</div>
					</For>
					<If condition={hasNext}>
						<ScrollDetect
							className="text-center"
							onVisible={this.getDepositHistory}
						>
							<i className="glyphicon glyphicon-repeat rkf-spin rkf-fw" />
						</ScrollDetect>
					</If>
				</div>
				<If
					condition={(depositHistory === null || depositHistory.length === 0) && !hasNext}
				>
					<br />
					<br />
					<div className="col-xs-12 text-muted text-center">
						{lang.t("No deposit history to display")}
					</div>
				</If>
			</div>
		);
	}
}

export default DepositHistory;
